import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, Renderer2, ApplicationRef } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { Client } from '@df/core/service/client';
@Component({
    selector: 'app',
    styles: [
        `
            :host {
                height: inherit;
            }
        `
    ],
    template: `<router-outlet></router-outlet>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
    protected client = inject(Client);
    protected elementRef = inject(ElementRef<HTMLElement>);
    protected changeDetectorRef = inject(ChangeDetectorRef);
    protected router = inject(Router);
    protected renderer2 = inject(Renderer2);
    protected document = inject(DOCUMENT);

    constructor() {
        this.client.isCms$.subscribe(isCms => {
            if (isCms) {
                this.setAsRoot(this.elementRef.nativeElement);
            } else {
                this.setAsRoot((this.document.scrollingElement || this.document.body) as HTMLElement);
            }
        });
    }
    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd || event instanceof NavigationError) {
                this.detectChanges();
            }
        });
    }

    private setAsRoot(element: HTMLElement) {
        const currentRoot = this.client.getRootElement();
        if (currentRoot !== element) {
            if (currentRoot) {
                this.renderer2.removeClass(currentRoot, 'app-root');
            }
            // app-root class is set in global.scss
            this.renderer2.addClass(element, 'app-root');
            this.client.setRootElement(element);
        }
    }
    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
